const WORLD_MUSIC_LYRICS = {
    'new-rulers': [
        { start: 1, end: 9, text: 'One, one, one, one, one' },
        { start: 9, end: 14, text: "Talkin' in my sleep at night, makin' myself crazy" },
        { start: 14, end: 17, text: '(Out of my mind, out of my mind)' },
        { start: 17, end: 22, text: "Wrote it down and read it out, hopin' it would save me" },
        { start: 22, end: 25, text: '(Too many times, too many times)' },
        { start: 25, end: 27, text: 'My love' },
        { start: 27, end: 33, text: 'He makes me feel like nobody else, nobody else' },
        { start: 33, end: 35, text: 'But my love' },
        { start: 35, end: 42, text: "He doesn't love me, so I tell myself, I tell myself" },
        { start: 42, end: 44, text: "One: Don't pick up the phone" },
        { start: 44, end: 46, text: "You know he's only callin' 'cause he's drunk and alone" },
        { start: 46, end: 50, text: "Two: Don't let him in, you'll have to kick him out again" },
        { start: 50, end: 52, text: "Three: Don't be his friend" },
        { start: 52, end: 55, text: "You know you're gonna wake up in his bed in the mornin'" },
        { start: 55, end: 58, text: "And if you're under him, you ain't gettin' over him" },
        { start: 58, end: 63, text: "I got new rules, I count 'em" },
        { start: 63, end: 67, text: "I got new rules, I count 'em" },
        { start: 67, end: 71, text: 'I gotta tell them to myself' },
        { start: 71, end: 75, text: "I got new rules, I count 'em" },
        { start: 75, end: 77, text: 'I gotta tell them to myself' },
        { start: 77, end: 82, text: "I keep pushin' forwards, but he keeps pullin' me backwards" },
        { start: 82, end: 84, text: '(Nowhere to turn) no way' },
        { start: 84, end: 85, text: '(Nowhere to turn) no' },
        { start: 85, end: 90, text: "Now I'm standin' back from it, I finally see the pattern" },
        { start: 90, end: 93, text: '(I never learn, I never learn)' },
        { start: 93, end: 96, text: 'But my love (love)' },
        { start: 96, end: 99, text: "He doesn't love me, so I tell myself" },
        { start: 99, end: 102, text: 'I tell myself, I do, I do, I do' },
        { start: 102, end: 104, text: "One: Don't pick up the phone" },
        { start: 104, end: 106, text: "You know he's only callin' 'cause he's drunk and alone" },
        { start: 106, end: 110, text: "Two: Don't let him in, you'll have to kick him out again" },
        { start: 110, end: 112, text: "Three: Don't be his friend" },
        { start: 112, end: 115, text: "You know you're gonna wake up in his bed in the mornin'" },
        { start: 115, end: 119, text: "And if you're under him, you ain't gettin' over him" },
        { start: 119, end: 122, text: "I got new rules, I count 'em" },
        { start: 122, end: 127, text: "I got new rules, I count 'em" },
        { start: 127, end: 131, text: 'I gotta tell them to myself' },
        { start: 131, end: 135, text: "I got new rules, I count 'em" },
        { start: 135, end: 137, text: 'I gotta tell them to myself' },
        {
            start: 137,
            end: 145,
            text: "Practice makes perfect, I'm still tryna learn it by heart (I got new rules, I count 'em)",
        },
        {
            start: 145,
            end: 153,
            text: "Eat, sleep and breathe it, rehearse and repeat it, 'cause I (I got new, I got new, I...)",
        },
        { start: 153, end: 156, text: "One: Don't pick up the phone" },
        { start: 156, end: 158, text: "You know he's only callin' 'cause he's drunk and alone" },
        { start: 158, end: 162, text: "Two: Don't let him in, you'll have to kick him out again" },
        { start: 162, end: 164, text: "Three: Don't be his friend" },
        { start: 164, end: 166, text: "You know you're gonna wake up in his bed in the mornin'" },
        { start: 166, end: 171, text: "And if you're under him, you ain't gettin' over him" },
        { start: 171, end: 175, text: "I got new rules, I count 'em" },
        { start: 175, end: 179, text: "I got new rules, I count 'em" },
        { start: 179, end: 183, text: 'I gotta tell them to myself' },
        { start: 183, end: 187, text: "I got new rules, I count 'em" },
        { start: 187, end: 189, text: 'I gotta tell them to myself' },
        { start: 189, end: 193, text: "Don't let him in, don't let him in, don't, don't, don't, don't" },
        { start: 193, end: 197, text: "Don't be his friend, don't be his friend, don't, don't, don't, don't" },
        { start: 197, end: 201, text: "Don't let him in, don't let him in, don't, don't, don't, don't" },
        { start: 201, end: 205, text: "Don't be his friend, don't be his friend, don't, don't, don't" },
        { start: 205, end: 208, text: "You gettin' over him" },
    ],
    'bad-guy': [
        { start: 14, end: 17, text: 'White shirt now red, my bloody nose' },
        { start: 17, end: 21, text: "Sleepin', you're on your tippy toes" },
        { start: 21, end: 25, text: "Creepin' around like no one knows" },
        { start: 25, end: 28, text: "Think you're so criminal" },
        { start: 28, end: 32, text: 'Bruises on both my knees for you' },
        { start: 32, end: 35, text: "Don't say thank you or please" },
        { start: 35, end: 39, text: "I do what I want when I'm wanting to" },
        { start: 39, end: 42, text: 'My soul? So cynical' },
        { start: 42, end: 43, text: "So you're a tough guy" },
        { start: 43, end: 45, text: 'Like it really rough guy' },
        { start: 45, end: 47, text: "Just can't get enough guy" },
        { start: 47, end: 49, text: 'Chest always so puffed guy' },
        { start: 49, end: 51, text: "I'm that bad type" },
        { start: 51, end: 52, text: 'Make your mama sad type' },
        { start: 52, end: 54, text: 'Make your girlfriend mad tight' },
        { start: 54, end: 56, text: 'Might seduce your dad type' },
        { start: 56, end: 61, text: "I'm the bad guy, duh" },
        { start: 67, end: 70, text: "I'm the bad guy" },
        { start: 75, end: 78, text: 'I like it when you take control' },
        { start: 78, end: 82, text: "Even if you know that you don't" },
        { start: 82, end: 85, text: "Own me, I'll let you play the role" },
        { start: 85, end: 89, text: "I'll be your animal" },
        { start: 89, end: 93, text: 'My mommy likes to sing along with me' },
        { start: 93, end: 96, text: "But she won't sing this song" },
        { start: 96, end: 99, text: 'If she reads all the lyrics' },
        { start: 99, end: 102, text: "She'll pity the men I know" },
        { start: 102, end: 104, text: "So you're a tough guy" },
        { start: 104, end: 105, text: 'Like it really rough guy' },
        { start: 105, end: 107, text: "Just can't get enough guy" },
        { start: 107, end: 110, text: 'Chest always so puffed guy' },
        { start: 110, end: 111, text: "I'm that bad type" },
        { start: 111, end: 113, text: 'Make your mama sad type' },
        { start: 113, end: 115, text: 'Make your girlfriend mad tight' },
        { start: 115, end: 117, text: 'Might seduce your dad type' },
        { start: 117, end: 121, text: "I'm the bad guy, duh" },
        { start: 127, end: 134, text: "I'm the bad guy, duh" },
        { start: 140, end: 148, text: "I'm only good at being bad, bad" },
        { start: 159, end: 163, text: 'I like when you get mad' },
        { start: 163, end: 167, text: "I guess I'm pretty glad that you're alone" },
        { start: 167, end: 169, text: "You said she's scared of me?" },
        { start: 169, end: 172, text: "I mean, I don't see what she sees" },
        { start: 172, end: 175, text: "But maybe it's 'cause I'm wearing your cologne" },
        { start: 177, end: 180, text: "I'm a bad guy" },
        { start: 185, end: 188, text: "I'm, I'm a bad guy" },
    ],
    idgaf: [
        { start: 5, end: 8, text: 'You call me all friendly' },
        { start: 8, end: 10, text: 'Telling me how much you miss me' },
        { start: 10, end: 15, text: "That's funny, I guess you've heard my songs" },
        { start: 15, end: 18, text: "Well, I'm too busy for your business" },
        { start: 18, end: 20, text: 'Go find a girl who wants to listen' },
        { start: 20, end: 22, text: "'Cause if you think I was born yesterday" },
        { start: 22, end: 24, text: 'You have got me wrong' },
        { start: 24, end: 26, text: 'So I cut you off' },
        { start: 26, end: 28, text: "I don't need your love" },
        { start: 28, end: 29, text: "'Cause I already cried enough" },
        { start: 29, end: 31, text: "I've been done" },
        { start: 31, end: 34, text: "I've been moving on, since we said goodbye" },
        { start: 34, end: 36, text: 'I cut you off' },
        { start: 36, end: 41, text: "I don't need your love, so you can try all you want" },
        { start: 41, end: 45, text: "Your time is up, I'll tell you why" },
        { start: 45, end: 47, text: "You say you're sorry" },
        { start: 47, end: 50, text: "But it's too late now" },
        { start: 50, end: 54, text: 'So save it, get gone, shut up' },
        { start: 54, end: 59, text: "'Cause if you think I care about you now" },
        { start: 59, end: 65, text: "Well, boy, I don't give a fuck" },
        { start: 65, end: 67, text: 'I remember that weekend' },
        { start: 67, end: 70, text: 'When my best friend caught you creeping' },
        { start: 70, end: 73, text: 'You blamed it all on the alcohol' },
        { start: 73, end: 77, text: 'So I made my decision' },
        { start: 77, end: 79, text: "'Cause you made your bed, sleep in it" },
        { start: 79, end: 82, text: 'Play the victim and switch your position' },
        { start: 82, end: 84, text: "I'm through, I'm done" },
        { start: 84, end: 85, text: 'So I cut you off' },
        { start: 85, end: 87, text: "I don't need your love" },
        { start: 87, end: 89, text: "'Cause I already cried enough" },
        { start: 89, end: 90, text: "I've been done" },
        { start: 90, end: 93, text: "I've been moving on, since we said goodbye" },
        { start: 93, end: 95, text: 'I cut you off' },
        { start: 95, end: 100, text: "I don't need your love, so you can try all you want" },
        { start: 100, end: 104, text: "Your time is up, I'll tell you why" },
        { start: 104, end: 106, text: "You say you're sorry" },
        { start: 106, end: 109, text: "But it's too late now" },
        { start: 109, end: 114, text: 'So save it, get gone, shut up' },
        { start: 114, end: 118, text: "'Cause if you think I care about you now" },
        { start: 118, end: 123, text: "Well, boy, I don't give a fuck" },
        { start: 123, end: 126, text: 'I see you tryna get to me' },
        { start: 126, end: 129, text: 'I see you begging on your knees' },
        { start: 129, end: 133, text: "Boy, I don't give a fuck" },
        { start: 133, end: 136, text: 'So stop tryna get to me' },
        { start: 136, end: 139, text: 'Tchh, get up off your knees' },
        { start: 139, end: 143, text: "'Cause, boy, I don't give a fu-u-uck" },
        { start: 143, end: 146, text: 'About you' },
        { start: 146, end: 149, text: "No, I don't give a damn" },
        { start: 149, end: 153, text: 'You keep reminiscing on when you were my man' },
        { start: 153, end: 155, text: "But I'm over you" },
        { start: 155, end: 158, text: "Now you're all in the past" },
        { start: 158, end: 163, text: "You talk all that sweet talk, but I ain't coming back" },
        { start: 163, end: 164, text: 'Cut you off' },
        { start: 164, end: 166, text: "I don't need your love" },
        { start: 166, end: 170, text: 'So you can try all you want' },
        { start: 170, end: 172, text: "Your time is up, I'll tell you why" },
        { start: 172, end: 173, text: "(I'll tell you why)" },
        { start: 173, end: 175, text: "You say you're sorry" },
        { start: 175, end: 178, text: "But it's too late now" },
        { start: 178, end: 182, text: 'So save it, get gone, shut up' },
        { start: 182, end: 183, text: '(Too late now)' },
        { start: 183, end: 188, text: "'Cause if you think I care about you now" },
        { start: 188, end: 191, text: "Well, boy, I don't give a fuck" },
        { start: 191, end: 192, text: "(Boy, I don't give a fuck)" },
        { start: 192, end: 195, text: 'I see you tryna get to me' },
        { start: 195, end: 198, text: 'I see you begging on your knees' },
        { start: 198, end: 202, text: "Boy, I don't give a fuck" },
        { start: 202, end: 205, text: 'So stop tryna get to me (get to me)' },
        { start: 205, end: 208, text: 'Tchh, get up off your knees' },
        { start: 208, end: 213, text: "'Cause, boy, I don't give a fuck" },
    ],
    problem: [
        { start: 3, end: 5, text: 'Uh-huh!' },
        { start: 5, end: 7, text: "It's Iggy Iggs!" },
        { start: 7, end: 11, text: 'I got one more problem with you girl, hey!' },
        { start: 11, end: 16, text: 'Hey baby, even though I hate ya, I wanna love ya (I want you)' },
        { start: 16, end: 20, text: "And even though I can't forgive ya, I really want to (I want you)" },
        { start: 20, end: 25, text: "Tell me, tell me, baby, why can't you leave me?" },
        { start: 25, end: 29, text: "'Cause even though I shouldn't want it, I gotta have it (I want you)" },
        { start: 29, end: 31, text: 'Head in the clouds' },
        { start: 31, end: 34, text: 'Got no weight on my shoulders' },
        { start: 34, end: 39, text: "I should be wiser, and realize that I've got" },
        { start: 39, end: 41, text: 'One less problem without ya' },
        { start: 41, end: 43, text: 'I got one less problem without ya' },
        { start: 43, end: 48, text: 'I got one less problem without ya (I got one less, one less problem)' },
        { start: 48, end: 50, text: 'One less problem without ya' },
        { start: 50, end: 52, text: 'I got one less problem without ya' },
        { start: 52, end: 58, text: 'I got one less problem without ya (I got one less, one less problem)' },
        { start: 62, end: 64, text: "I know you're never gonna wake up" },
        { start: 64, end: 67, text: "I gotta give up (but it's you)" },
        { start: 67, end: 71, text: "I know I shouldn't ever call back or let you come back (but it's you)" },
        { start: 71, end: 78, text: 'Every time you touch me and say you love me, I get a little bit breathless' },
        { start: 78, end: 81, text: "I shouldn't want it (but it's you)" },
        { start: 81, end: 83, text: 'Head in the clouds' },
        { start: 83, end: 86, text: 'Got no weight on my shoulders' },
        { start: 86, end: 90, text: "I should be wiser, and realize that I've got" },
        { start: 90, end: 92, text: 'One less problem without ya' },
        { start: 92, end: 94, text: 'I got one less problem without ya' },
        { start: 94, end: 99, text: 'I got one less problem without ya (I got one less, one less problem)' },
        { start: 99, end: 101, text: 'One less problem without ya' },
        { start: 101, end: 104, text: 'I got one less problem without ya' },
        { start: 104, end: 109, text: 'I got one less problem without ya (I got one less, one less problem)' },
        { start: 110, end: 112, text: "It's Iggy Iggs!" },
        { start: 112, end: 114, text: 'Uh, what you got?' },
        { start: 114, end: 116, text: "Smart money bettin' I'll be better off without you" },
        { start: 116, end: 118, text: "In no time I'll be forgettin' all about you" },
        { start: 118, end: 121, text: "You sayin' that you know but I really, really doubt you understand" },
        { start: 121, end: 123, text: "My life is easy when I ain't around you" },
        { start: 123, end: 125, text: "Iggy Iggy, too big to be here stressin'" },
        { start: 125, end: 127, text: "I'm thinkin' I love the thought of you more than I love your presence" },
        { start: 127, end: 130, text: 'And the best thing now is probably for you to exit' },
        { start: 130, end: 132, text: 'I let you go, let you back, I finally learned my lesson' },
        { start: 132, end: 134, text: "No half-stepping, either you want it or you just playin'" },
        { start: 134, end: 136, text: "I'm listenin' to you knowin' I can't believe what you're sayin'" },
        { start: 136, end: 139, text: "There's a million yous, baby boo, so don't be dumb" },
        { start: 139, end: 141, text: "I got 99 problems but you won't be one" },
        { start: 141, end: 143, text: 'Like what' },
        { start: 143, end: 148, text: 'Mm-mm na-na-na (one less, one less problem)' },
        { start: 148, end: 151, text: 'Mm-mm, yeah (one less, one less problem)' },
        { start: 151, end: 153, text: 'Head in the clouds' },
        { start: 153, end: 156, text: 'Got no weight on my shoulders' },
        { start: 156, end: 162, text: "I should be wiser, and realize that I've got" },
        { start: 162, end: 164, text: 'One less problem without ya (hey)' },
        { start: 164, end: 167, text: 'I got one less problem without ya (no, babe)' },
        {
            start: 167,
            end: 172,
            text: 'I got one less problem without ya (ooh, ooh, baby) (I got one less, one less problem)',
        },
        { start: 172, end: 174, text: 'One less problem without ya (hey)' },
        { start: 174, end: 176, text: 'I got one less problem without ya (no, babe)' },
        {
            start: 176,
            end: 181,
            text: 'I got one less problem without ya (ooh, ooh, baby) (I got one less, one less problem)',
        },
        { start: 181, end: 183, text: 'One less problem without ya (hey)' },
        { start: 183, end: 185, text: 'I got one less problem without ya (no, babe)' },
        {
            start: 185,
            end: 192,
            text: 'I got one less problem without ya (ooh, ooh, baby) (I got one less, one less problem)',
        },
    ],
    '7-rings': [
        { start: 13, end: 17, text: "Yeah, breakfast at Tiffany's and bottles of bubbles" },
        { start: 17, end: 21, text: 'Girls with tattoos who like getting in trouble' },
        { start: 21, end: 24, text: 'Lashes and diamonds, ATM machines' },
        { start: 24, end: 28, text: 'Buy myself all of my favourite things, yeah' },
        { start: 28, end: 31, text: 'Been through some bad shit, I should be a sad bitch' },
        { start: 31, end: 34, text: "Who would have thought it'd turn me to a savage?" },
        { start: 34, end: 38, text: 'Rather be tied up with calls and not strings' },
        { start: 38, end: 41, text: 'Write my own checks like I write what I sing, yeah' },
        { start: 41, end: 44, text: "My wrist, stop watchin', my neck is flossy" },
        { start: 44, end: 48, text: "Make big deposits, my gloss is poppin'" },
        { start: 48, end: 51, text: 'You like my hair? Gee, thanks, just bought it' },
        { start: 51, end: 55, text: 'I see it, I like it, I want it, I got it, yeah' },
        { start: 55, end: 58, text: 'I want it, I got it, I want it, I got it' },
        { start: 58, end: 62, text: 'I want it, I got it, I want it, I got it' },
        { start: 62, end: 65, text: 'You like my hair? Gee, thanks, just bought it' },
        { start: 65, end: 68, text: 'I see it, I like it, I want it, I got it (yep)' },
        { start: 68, end: 72, text: "Wearing a ring, but ain't gon' be no 'Mrs'" },
        { start: 72, end: 76, text: 'Bought matching diamonds for six of my bitches' },
        { start: 76, end: 79, text: "I'd rather spoil all my friends with my riches" },
        { start: 79, end: 82, text: 'Think retail therapy my new addiction' },
        { start: 82, end: 86, text: "Whoever said money can't solve your problems" },
        { start: 86, end: 89, text: "Must not have had enough money to solve 'em" },
        { start: 89, end: 93, text: "They say, 'Which one?', I say, 'Nah, I want all of 'em'" },
        { start: 93, end: 96, text: 'Happiness is the same price as red-bottoms' },
        { start: 96, end: 99, text: "My smile is beamin' (yeah), my skin is gleamin' (is gleamin')" },
        { start: 99, end: 103, text: "The way it shine, I know you've seen it (you've seen it)" },
        { start: 103, end: 106, text: 'I bought a crib just for (just for) the closet (closet)' },
        { start: 106, end: 110, text: 'Both his and hers, I want it, I got it, yeah' },
        { start: 110, end: 113, text: 'I want it, I got it, I want it, I got it' },
        { start: 113, end: 116, text: 'I want it, I got it, I want it, I got it (baby)' },
        { start: 116, end: 120, text: 'You like my hair? Gee, thanks, just bought it (oh yeah)' },
        { start: 120, end: 123, text: 'I see it, I like it, I want it, I got it (yep)' },
        { start: 123, end: 125, text: "Yeah, my receipts be lookin' like phone numbers" },
        { start: 125, end: 127, text: "If it ain't money, then wrong number" },
        { start: 127, end: 128, text: 'Black card is my business card' },
        { start: 128, end: 130, text: "The way it be settin' the tone for me" },
        { start: 130, end: 134, text: "I don't mean to brag, but I be like, 'Put it in the bag', yeah" },
        { start: 134, end: 137, text: 'When you see them racks, they stacked up like my ass, yeah' },
        { start: 137, end: 139, text: 'Shoot, go from the store to the booth' },
        { start: 139, end: 141, text: 'Make it all back in one loop, give me the loot' },
        { start: 141, end: 142, text: 'Never mind, I got the juice' },
        { start: 142, end: 144, text: 'Nothing but net when we shoot' },
        { start: 144, end: 145, text: 'Look at my neck, look at my jet' },
        { start: 145, end: 147, text: "Ain't got enough money to pay me respect" },
        { start: 147, end: 149, text: "Ain't no budget when I'm on the set" },
        { start: 149, end: 151, text: "If I like it, then that's what I get, yeah" },
        { start: 151, end: 154, text: 'I want it, I got it, I want it, I got it (yeah)' },
        { start: 154, end: 157, text: 'I want it, I got it, I want it, I got it (oh yeah, yeah)' },
        { start: 157, end: 161, text: 'You like my hair? Gee, thanks, just bought it' },
        { start: 161, end: 167, text: 'I see it, I like it, I want it, I got it (yep)' },
    ],
    'do-not-let-me-down': [
        { start: 13, end: 16, text: 'Crashing, hit a wall' },
        { start: 16, end: 18, text: 'Right now I need a miracle' },
        { start: 18, end: 25, text: 'Hurry up now, I need a miracle' },
        { start: 25, end: 28, text: 'Stranded, reaching out' },
        { start: 28, end: 31, text: "I call your name, but you're not around" },
        { start: 31, end: 36, text: "I say your name, but you're not around" },
        { start: 36, end: 39, text: 'I need you, I need you, I need you right now' },
        { start: 39, end: 42, text: 'Yeah, I need you right now' },
        { start: 42, end: 45, text: "So don't let me, don't let me, don't let me down" },
        { start: 45, end: 47, text: "I think I'm losing my mind now" },
        { start: 47, end: 50, text: "It's in my head, darling, I hope" },
        { start: 50, end: 53, text: "That you'll be here, when I need you the most" },
        { start: 53, end: 57, text: "So don't let me, don't let me, don't let me down" },
        { start: 57, end: 59, text: "D-don't let me down" },
        { start: 59, end: 64, text: "Don't let me down" },
        { start: 64, end: 68, text: "Don't let me down, down, down" },
        { start: 68, end: 73, text: "Don't let me down, don't let me down, down, down" },
        { start: 73, end: 76, text: 'Running out of time' },
        { start: 76, end: 79, text: 'I really thought you were on my side' },
        { start: 79, end: 84, text: "But now there's nobody by my side" },
        { start: 84, end: 88, text: 'I need you, I need you, I need you right now' },
        { start: 88, end: 90, text: 'Yeah, I need you right now' },
        { start: 90, end: 93, text: "So don't let me, don't let me, don't let me down" },
        { start: 93, end: 95, text: "I think I'm losing my mind now" },
        { start: 95, end: 98, text: "It's in my head, darling, I hope" },
        { start: 98, end: 101, text: "That you'll be here, when I need you the most" },
        { start: 101, end: 105, text: "So don't let me, don't let me, don't let me down" },
        { start: 105, end: 107, text: "D-don't let me down" },
        { start: 107, end: 112, text: "Don't let me down" },
        { start: 112, end: 118, text: "Don't let me down, down, down" },
        { start: 118, end: 124, text: "Don't let me down, down, down" },
        { start: 124, end: 128, text: "Don't let me down, down, down" },
        { start: 128, end: 135, text: "Don't let me down, don't let me down, down, down" },
        { start: 135, end: 140, text: "Ooh, I think I'm losing my mind now, yeah" },
        { start: 140, end: 144, text: "Ooh, I think I'm losing my mind now, yeah" },
        { start: 144, end: 148, text: 'I need you, I need you, I need you right now' },
        { start: 148, end: 150, text: 'Yeah, I need you right now' },
        { start: 150, end: 153, text: "So don't let me, don't let me, don't let me down" },
        { start: 153, end: 155, text: "I think I'm losing my mind now" },
        { start: 155, end: 158, text: "It's in my head, darling, I hope" },
        { start: 158, end: 161, text: "That you'll be here, when I need you the most" },
        { start: 161, end: 166, text: "So don't let me, don't let me, don't let me down" },
        { start: 166, end: 171, text: "Don't let me down" },
        { start: 171, end: 176, text: "Yeah, don't let me down" },
        { start: 176, end: 184, text: "Yeah, don't let me down" },
        { start: 184, end: 188, text: "Don't let me down, oh, no" },
        { start: 188, end: 190, text: "Said don't let me down" },
        { start: 190, end: 191, text: "Don't let me down" },
        { start: 191, end: 196, text: "Don't let me down" },
        { start: 196, end: 202, text: "Don't let me down, down, down" },
    ],
    friends: [
        { start: 0, end: 4, text: 'Ooh ooh, ooh ooh' },
        { start: 4, end: 10, text: 'Ooh ooh, ooh ooh' },
        { start: 10, end: 12, text: 'You say you love me, I say you crazy' },
        { start: 12, end: 15, text: "We're nothing more than friends" },
        { start: 15, end: 17, text: "You're not my lover, more like a brother" },
        { start: 17, end: 20, text: 'I known you since we were like ten, yeah' },
        { start: 20, end: 23, text: "Don't mess it up, talking that shit" },
        { start: 23, end: 25, text: "Only gonna push me away, that's it" },
        { start: 25, end: 27, text: 'When you say you love me, that make me crazy' },
        { start: 27, end: 29, text: 'Here we go again' },
        { start: 29, end: 34, text: "Don't go look at me with that look in your eye" },
        { start: 34, end: 39, text: "You really ain't going away without a fight" },
        { start: 39, end: 44, text: "You can't be reasoned with, I'm done being polite" },
        { start: 44, end: 49, text: "I've told you one, two, three, four, five, six thousand times" },
        { start: 49, end: 52, text: "Haven't I made it obvious?" },
        { start: 52, end: 54, text: "Haven't I made it clear?" },
        { start: 54, end: 57, text: 'Want me to spell it out for you?' },
        { start: 57, end: 59, text: 'F-R-I-E-N-D-S' },
        { start: 59, end: 62, text: "Haven't I made it obvious?" },
        { start: 62, end: 64, text: "Haven't I made it clear?" },
        { start: 64, end: 66, text: 'Want me to spell it out for you?' },
        { start: 66, end: 69, text: 'F-R-I-E-N-D-S' },
        { start: 69, end: 70, text: 'F-R-I-E-N-D-S' },
        { start: 70, end: 73, text: 'Have you got no shame? You looking insane' },
        { start: 73, end: 76, text: 'Turning up at my door' },
        { start: 76, end: 78, text: "It's two in the morning, the rain is pouring" },
        { start: 78, end: 80, text: "Haven't we been here before?" },
        { start: 80, end: 83, text: "Don't mess it up, talking that shit" },
        { start: 83, end: 86, text: "Only gonna push me away, that's it" },
        { start: 86, end: 89, text: 'Have you got no shame? You looking insane' },
        { start: 89, end: 90, text: 'Here we go again' },
        { start: 90, end: 95, text: "So don't go look at me with that look in your eye" },
        { start: 95, end: 100, text: "You really ain't going away without a fight" },
        { start: 100, end: 105, text: "You can't be reasoned with, I'm done being polite" },
        { start: 105, end: 110, text: "I've told you one, two, three, four, five, six thousand times" },
        { start: 110, end: 112, text: "Haven't I made it obvious? (Haven't I made it?)" },
        { start: 112, end: 115, text: "Haven't I made it clear? (Haven't I made it clear?)" },
        { start: 115, end: 117, text: 'Want me to spell it out for you?' },
        { start: 117, end: 120, text: 'F-R-I-E-N-D-S' },
        { start: 120, end: 122, text: "Haven't I made it obvious?" },
        { start: 122, end: 125, text: "Haven't I made it clear? (Haven't I?)" },
        { start: 125, end: 127, text: 'Want me to spell it out for you? (To spell it out for you?)' },
        { start: 127, end: 130, text: 'F-R-I-E-N-D-S' },
        { start: 130, end: 131, text: 'F-R-I-E-N-D-S' },
        { start: 131, end: 134, text: 'F-R-I-E-N-D-S' },
        { start: 134, end: 136, text: "That's how you f- spell 'friends'" },
        { start: 136, end: 139, text: 'F-R-I-E-N-D-S' },
        { start: 139, end: 142, text: 'Get that shit inside your head' },
        { start: 142, end: 146, text: 'No, no, yeah, uh, ah' },
        { start: 146, end: 149, text: 'F-R-I-E-N-D-S' },
        { start: 149, end: 150, text: "We're just friends" },
        { start: 150, end: 155, text: "So don't go look at me with that look in your eye" },
        { start: 155, end: 161, text: "You really ain't going nowhere without a fight" },
        { start: 161, end: 166, text: "You can't be reasoned with, I'm done being polite" },
        { start: 166, end: 170, text: "I've told you one, two, three, four, five, six thousand times" },
        { start: 170, end: 173, text: "Haven't I made it obvious? (Have I not made it obvious?)" },
        { start: 173, end: 175, text: "Haven't I made it clear? (I made it very clear)" },
        { start: 175, end: 178, text: 'Want me to spell it out for you? (Yo)' },
        { start: 178, end: 181, text: 'F-R-I-EN-D-S (I said F-R-I-E-N-D-S)' },
        { start: 181, end: 183, text: "Haven't I made it obvious? (I made it very obvious)" },
        { start: 183, end: 185, text: "Haven't I made it clear? (I made it very clear)" },
        { start: 185, end: 188, text: 'Want me to spell it out for you?' },
        { start: 188, end: 190, text: 'F-R-I-E-N-D-S' },
        { start: 190, end: 192, text: 'F-R-I-E-N-D-S' },
        { start: 192, end: 197, text: 'Mmm, ooh ooh, ooh ooh' },
        { start: 197, end: 202, text: 'Ah, ah-oh, ah' },
    ],
    'light-switch': [
        { start: 11, end: 12, text: 'Yeah' },
        { start: 12, end: 15, text: "Why you callin' at 11:30" },
        { start: 15, end: 19, text: 'When you only wanna do me dirty?' },
        { start: 19, end: 23, text: "But I hit right back 'cause you got that, that, yeah" },
        { start: 23, end: 25, text: 'Why you always wanna act like lovers' },
        { start: 25, end: 29, text: "But you never wanna be each other's?" },
        { start: 29, end: 32, text: `I say, "Don't look back" but I go right back and` },
        { start: 32, end: 35, text: "All of a sudden, I'm hypnotized" },
        { start: 35, end: 38, text: "You're the one that I can't deny" },
        { start: 38, end: 42, text: "Every time that I say I'm gonna walk away" },
        { start: 42, end: 45, text: 'You turn me on like a light switch' },
        { start: 45, end: 48, text: "When you're movin' your body around and around" },
        { start: 48, end: 50, text: "Now, I don't wanna fight this (no)" },
        { start: 50, end: 52, text: 'You know how to just make me want' },
        { start: 52, end: 55, text: 'You turn me on like a light switch' },
        { start: 55, end: 58, text: "When you're movin' your body around and around" },
        { start: 58, end: 61, text: 'You got me in a tight grip (yeah)' },
        { start: 61, end: 65, text: 'You know how to just make me want you, baby' },
        { start: 65, end: 68, text: "Do you love it when you keep me guessin'? (Me guessin')" },
        { start: 68, end: 72, text: "When you leave, and then you leave me stressin' (me stressin')" },
        { start: 72, end: 76, text: "But I can't stay mad when you walk like that, no (uh)" },
        { start: 76, end: 78, text: 'Why you always wanna act like lovers' },
        { start: 78, end: 82, text: "But you never wanna be each other's?" },
        { start: 82, end: 85, text: "I say don't look back, but I go right back and" },
        { start: 85, end: 88, text: "All of a sudden, I'm hypnotized (hypnotized)" },
        { start: 88, end: 90, text: "You're the one that I can't deny (can't deny)" },
        { start: 90, end: 95, text: "Every time that I say I'm gonna walk away (yeah)" },
        { start: 95, end: 98, text: 'You turn me on like a light switch' },
        { start: 98, end: 101, text: "When you're movin' your body around and around" },
        { start: 101, end: 103, text: "Now, I don't wanna fight this (no)" },
        { start: 103, end: 105, text: 'You know how to just make me want' },
        { start: 105, end: 108, text: 'You turn me on like a light switch (switch)' },
        { start: 108, end: 111, text: "When you're movin' your body around and around" },
        { start: 111, end: 113, text: 'You got me in a tight grip (grip)' },
        { start: 113, end: 117, text: 'You know how to just make me want you, baby' },
        { start: 117, end: 120, text: "C'mon, c'mon, c'mon, c'mon" },
        { start: 120, end: 123, text: "C'mon and show me how you do (do)" },
        { start: 123, end: 125, text: 'You want, you want, you want, you want' },
        { start: 125, end: 128, text: "You wanna keep me wantin' you (me wantin' you, girl)" },
        { start: 128, end: 130, text: "C'mon, c'mon, c'mon, c'mon" },
        { start: 130, end: 133, text: "C'mon and show me how you do (you do)" },
        { start: 133, end: 135, text: 'You want, you want, you want, you want' },
        { start: 135, end: 137, text: "You wanna keep me wantin' you" },
        { start: 137, end: 139, text: 'You turn me on like a light switch' },
        { start: 139, end: 142, text: "When you're movin' your body around and around" },
        { start: 142, end: 144, text: "Now, I don't wanna fight this" },
        { start: 144, end: 150, text: 'You know how to just make me want you' },
        { start: 150, end: 152, text: 'You turn me on like a light switch' },
        { start: 152, end: 156, text: "When you're movin' your body around and around" },
        { start: 156, end: 158, text: 'You got me in a tight grip' },
        { start: 158, end: 163, text: 'You know how to just make me want you, baby' },
        { start: 163, end: 165, text: "C'mon, c'mon, c'mon, c'mon" },
        { start: 165, end: 168, text: "C'mon and show me how you do (how you do)" },
        { start: 168, end: 170, text: 'You want, you want, you want, you want' },
        { start: 170, end: 173, text: "You wanna keep me wantin' you (baby)" },
        { start: 173, end: 175, text: "C'mon, c'mon, c'mon, c'mon" },
        { start: 175, end: 178, text: "C'mon and show me how you do (how you do)" },
        { start: 178, end: 180, text: 'You want, you want, you want, you want' },
        { start: 180, end: 184, text: "You wanna keep me wantin' you" },
    ],
    'typa-girl': [
        { start: 15, end: 19, text: `Typa girl that'll make you wanna dream` },
        { start: 19, end: 22, text: `Typa girl that came straight off of the screen (screen, screen)` },
        { start: 22, end: 26, text: `Typa girl you wanna ice up, make me freeze (hot, hot)` },
        { start: 26, end: 28, text: `Typa girl you wanna wife up, sign the pre` },
        { start: 28, end: 32, text: `I bring money to the table, not your dinner` },
        { start: 32, end: 36, text: `Both my body and my bank account, good figure` },
        { start: 36, end: 40, text: `Thinkin' 'bout me, but there's nothing to consider` },
        { start: 40, end: 44, text: `If I let you in my circle, you a winner` },
        { start: 44, end: 48, text: `Didn't know that you were cold 'til you felt my fire` },
        { start: 48, end: 52, text: `Heaven's gate just opened up, hearing choirs` },
        { start: 52, end: 57, text: `If you say something else, you a liar` },
        { start: 57, end: 62, text: `'Cause I'm that girl that drive you crazy, but you can't leave me alone` },
        { start: 62, end: 66, text: `Got you thinkin' maybe I went supernatural` },
        { start: 66, end: 69, text: `Put you under spells or look into a crystal ball` },
        { start: 69, end: 73, text: `I'm not like these other girls at all` },
        { start: 73, end: 76, text: `I'm the typa girl that make you forget that you got a type` },
        { start: 76, end: 80, text: `Type that make you love me when the only thing you done is like` },
        { start: 80, end: 83, text: `I'm that typa girl, I'm that typa girl` },
        { start: 83, end: 86, text: `I'm that typa girl, I'm that typa girl` },
        { start: 86, end: 90, text: `Like du-du-dun, du-du-du-dun` },
        { start: 90, end: 94, text: `Like du-du-dun, du-du-du-dun` },
        { start: 94, end: 96, text: `Uh, I'm the type of girl that everybody type` },
        { start: 96, end: 98, text: `Double tap, tap, tap, what everybody like` },
        { start: 98, end: 100, text: `You can check my stats, got everybody's eye` },
        { start: 100, end: 102, text: `And I run them laps, 'round everybody's mind` },
        { start: 102, end: 104, text: `All of these girls on some uppercase shit` },
        { start: 104, end: 106, text: `That mean they all cap` },
        { start: 106, end: 107, text: `Being the best at whatever I do` },
        { start: 107, end: 108, text: `That's sounding on brand` },
        { start: 108, end: 112, text: `Typa girl that you wish for when you blow that candle out` },
        { start: 112, end: 116, text: `Typa girl that you wanna take back to your mama house` },
        { start: 116, end: 120, text: `Typa girl that don't ask for what she wants, she's takin' out` },
        { start: 120, end: 124, text: `Typa girl who got bag in same quality as Chanel` },
        { start: 124, end: 128, text: `Now you know that you were cold 'cause you felt my fire` },
        { start: 128, end: 132, text: `Heaven's gate just opened up, hearing choirs` },
        { start: 132, end: 137, text: `If you say something else, you a liar` },
        { start: 137, end: 142, text: `'Cause I'm that girl that drive you crazy, but you can't leave me alone` },
        { start: 142, end: 146, text: `Got you thinkin' maybe I went supernatural` },
        { start: 146, end: 149, text: `Put you under spells or look into a crystal ball` },
        { start: 149, end: 153, text: `I'm not like these other girls at all` },
        { start: 153, end: 156, text: `I'm the typa girl that make you forget that you got a type` },
        { start: 156, end: 160, text: `Type that make you love me when the only thing you done is like` },
        { start: 160, end: 164, text: `I'm that typa girl, I'm that typa girl` },
        { start: 164, end: 167, text: `I'm that typa girl, I'm that typa girl` },
        { start: 167, end: 170, text: `Like du-du-dun, du-du-du-dun` },
        { start: 170, end: 176, text: `Like du-du-dun, du-du-du-dun` },
    ],
    'время-не-пришло': [
        { start: 13, end: 18, text: `Детка, я влюблён. Не беру твой телефон (пррр!)` },
        { start: 18, end: 22, text: `Ты же знаешь, я с другой. Забывай меня и всё.` },
        { start: 22, end: 26, text: `Наше время не пришло. Наше время не пришло (эй!)` },
        { start: 26, end: 31, text: `Детка, я влюблён. Не беру твой телефон (пррр!)` },
        { start: 31, end: 35, text: `Ты же знаешь, я с другой. Забывай меня и всё.` },
        { start: 35, end: 41, text: `Наше время не пришло. Наше время не пришло.` },
        { start: 41, end: 45, text: `Так просто сказать, когда ты не рядом,` },
        { start: 45, end: 48, text: `Так просто молчать, когда всё ясно по взгляду.` },
        { start: 48, end: 52, text: `Не просто прощать, когда рушишь клятву.` },
        { start: 52, end: 53, text: `Мы хотим доверять, но так сложно понять,` },
        { start: 53, end: 55, text: `Где ложь, а где правда.` },
        { start: 55, end: 58, text: `Какие панчлайны? В отношениях и так всё не просто.` },
        { start: 58, end: 62, text: `Мы всегда на пути туда, где нам страшно и где очень остро.` },
        { start: 62, end: 65, text: `Наш маленький остров - наша постель, но снова` },
        { start: 65, end: 68, text: `Другая кровать и снова не ты, снова дурацкий отель.` },
        { start: 68, end: 71, text: `Ты прости, отпусти` },
        { start: 71, end: 74, text: `И будь с ним счастливой` },
        { start: 74, end: 78, text: `Но только тихий мой дом запомнил любовь` },
        { start: 78, end: 80, text: `И твой запах духов.` },
        { start: 80, end: 85, text: `Детка, я влюблён. Не беру твой телефон (пррр!)` },
        { start: 85, end: 89, text: `Ты же знаешь, я с другой. Забывай меня и всё.` },
        { start: 89, end: 94, text: `Наше время не пришло. Наше время не пришло (эй!)` },
        { start: 94, end: 99, text: `Детка, я влюблён. Не беру твой телефон (пррр!)` },
        { start: 99, end: 103, text: `Ты же знаешь, я с другой. Забывай меня и всё.` },
        { start: 103, end: 108, text: `Наше время не пришло. Наше время не пришло.` },
        { start: 108, end: 110, text: `Давай подчинять и сдаваться - да` },
        { start: 110, end: 112, text: `Разъярять, обижаться - да` },
        { start: 112, end: 114, text: `Отпускать, чтоб цепляться - да` },
        { start: 114, end: 116, text: `Разрешать ошибаться.` },
        { start: 116, end: 117, text: `Позволять ревновать,` },
        { start: 117, end: 119, text: `(Хм) но не соревноваться.` },
        { start: 119, end: 121, text: `Если собрать все по миру слова о любви -` },
        { start: 121, end: 123, text: `То рассказ о тебе будет вкратце.` },
        { start: 123, end: 124, text: `Мы как Канье и Ким?` },
        { start: 124, end: 125, text: `Нет - больше, как Джоли и Питт.` },
        { start: 125, end: 127, text: `Ты меня видишь с другой, я тебя вижу с другим.` },
        { start: 127, end: 129, text: `Соври и скажи, что не ёкнет внутри.` },
        { start: 129, end: 130, text: `Мы не Барби и Кен` },
        { start: 130, end: 132, text: `Хотя, лучше б за нас всё решили, как в "Симсе".` },
        { start: 132, end: 134, text: `Хочешь вернуться в тот день, ощутить всё?` },
        { start: 134, end: 136, text: `Просто усни, и мы там очутимся.` },
        { start: 136, end: 139, text: `Ты прости, отпусти` },
        { start: 139, end: 142, text: `И будь с ним счастливой` },
        { start: 142, end: 146, text: `Но только тихий мой дом запомнил любовь` },
        { start: 146, end: 148, text: `И твой запах духов.` },
        { start: 148, end: 153, text: `Детка, я влюблён. Не беру твой телефон (пррр!)` },
        { start: 153, end: 157, text: `Ты же знаешь, я с другой. Забывай меня и всё.` },
        { start: 157, end: 162, text: `Наше время не пришло. Наше время не пришло (эй!)` },
        { start: 162, end: 166, text: `Детка, я влюблён. Не беру твой телефон (пррр!)` },
        { start: 166, end: 170, text: `Ты же знаешь, я с другой. Забывай меня и всё.` },
        { start: 170, end: 177, text: `Наше время не пришло. Наше время не пришло.` },
        { start: 177, end: 180, text: `Просто ответь мне:` },
        { start: 180, end: 182, text: `Что для тебя значит Любить` },
        { start: 182, end: 185, text: `Что для тебя значит Любовь?` },
        { start: 185, end: 188, text: `Ведь кто-то сказал, что её не бывает.` },
        { start: 188, end: 193, text: `Ну, мы же им не верим!` },
    ],
    timber: [
        { start: 7, end: 11, text: `It's going down, I'm yelling timber` },
        { start: 11, end: 15, text: `You better move, you better dance` },
        { start: 15, end: 19, text: `Let's make a night, you won't remember` },
        { start: 19, end: 23, text: `I'll be the one, you won't forget` },
        { start: 38, end: 39, text: `The bigger they are, the harder they fall` },
        { start: 39, end: 41, text: `This biggity boy's a diggity dog` },
        { start: 41, end: 43, text: `I have 'em like Miley Cyrus, clothes off` },
        { start: 43, end: 45, text: `Twerking in their bras and thongs, timber` },
        { start: 45, end: 47, text: `Face down, booty up, timber` },
        { start: 47, end: 49, text: `That's the way we like the what, timber` },
        { start: 49, end: 50, text: `I'm slicker than an oil spill` },
        { start: 50, end: 52, text: `She say she won't, but I bet she will, timber` },
        { start: 52, end: 54, text: `Swing your partner round and round` },
        { start: 54, end: 56, text: `End of the night, it's going down` },
        { start: 56, end: 58, text: `One more shot, another round` },
        { start: 58, end: 60, text: `End of the night, it's going down` },
        { start: 60, end: 62, text: `Swing your partner round and round` },
        { start: 62, end: 63, text: `End of the night, it's going down` },
        { start: 63, end: 65, text: `One more shot, another round` },
        { start: 65, end: 66, text: `End of the night, it's going down` },
        { start: 66, end: 70, text: `It's going down, I'm yelling timber` },
        { start: 70, end: 74, text: `You better move, you better dance` },
        { start: 74, end: 78, text: `Let's make a night, you won't remember` },
        { start: 78, end: 81, text: `I'll be the one, you won't forget` },
        { start: 81, end: 85, text: `It's going down, I'm yelling timber` },
        { start: 85, end: 89, text: `You better move, you better dance` },
        { start: 89, end: 92, text: `Let's make a night, you won't remember` },
        { start: 92, end: 97, text: `I'll be the one, you won't forget` },
        { start: 112, end: 113, text: `Look up in the sky, it's a bird, it's a plane` },
        { start: 113, end: 115, text: `Nah, it's just me, ain't a damn thing changed` },
        { start: 115, end: 117, text: `Live in hotels, swing on plane` },
        { start: 117, end: 119, text: `Blessed to say, money ain't a thing` },
        { start: 119, end: 121, text: `Club jumping like Lebron, now, Voli` },
        { start: 121, end: 123, text: `Order me another round, homie` },
        { start: 123, end: 126, text: `We about to climb, wild, 'cause it's about to go down` },
        { start: 126, end: 128, text: `Swing your partner round and round` },
        { start: 128, end: 130, text: `End of the night, it's going down` },
        { start: 130, end: 132, text: `One more shot, another round` },
        { start: 132, end: 134, text: `End of the night, it's going down` },
        { start: 134, end: 135, text: `Swing your partner round and round` },
        { start: 135, end: 137, text: `End of the night, it's going down` },
        { start: 137, end: 139, text: `One more shot, another round` },
        { start: 139, end: 140, text: `End of the night, it's going down` },
        { start: 140, end: 144, text: `It's going down, I'm yelling timber` },
        { start: 144, end: 148, text: `You better move, you better dance` },
        { start: 148, end: 151, text: `Let's make a night, you won't remember` },
        { start: 151, end: 155, text: `I'll be the one, you won't forget` },
        { start: 155, end: 159, text: `It's going down, I'm yelling timber` },
        { start: 159, end: 162, text: `You better move, you better dance` },
        { start: 162, end: 166, text: `Let's make a night, you won't remember` },
        { start: 166, end: 172, text: `I'll be the one, you won't forget` },
    ],
    'the-nights': [
        { start: 1, end: 3, text: `Once upon a younger year` },
        { start: 3, end: 5, text: `When all our shadows disappeared` },
        { start: 5, end: 9, text: `The animals inside came out to play` },
        { start: 9, end: 11, text: `Went face to face with all our fears` },
        { start: 11, end: 13, text: `Learned our lessons through the tears` },
        { start: 13, end: 16, text: `Made memories we knew would never fade` },
        { start: 16, end: 20, text: `One day, my father, he told me, "Son, don't let it slip away"` },
        { start: 20, end: 24, text: `He took me in his arms, I heard him say` },
        { start: 24, end: 28, text: `"When you get older your wild heart will live for younger days` },
        { start: 28, end: 31, text: `Think of me if ever you're afraid"` },
        { start: 31, end: 35, text: `He said, "One day, you'll leave this world behind` },
        { start: 35, end: 39, text: `So live a life you will remember"` },
        { start: 39, end: 43, text: `My father told me when I was just a child` },
        { start: 43, end: 46, text: `"These are the nights that never die"` },
        { start: 46, end: 49, text: `My father told me` },
        { start: 77, end: 79, text: `"When thunderclouds start pouring down` },
        { start: 79, end: 81, text: `Light a fire they can't put out` },
        { start: 81, end: 84, text: `Carve your name into those shining stars"` },
        { start: 84, end: 87, text: `He said, "Go venture far beyond the shores` },
        { start: 87, end: 89, text: `Don't forsake this life of yours` },
        { start: 89, end: 92, text: `I'll guide you home no matter where you are"` },
        { start: 92, end: 96, text: `One day, my father, he told me, "Son, don't let it slip away"` },
        { start: 96, end: 100, text: `When I was just a kid, I heard him say` },
        { start: 100, end: 104, text: `"When you get older your wild heart will live for younger days` },
        { start: 104, end: 108, text: `Think of me if ever you're afraid"` },
        { start: 108, end: 111, text: `He said, "One day, you'll leave this world behind` },
        { start: 111, end: 115, text: `So live a life you will remember"` },
        { start: 115, end: 119, text: `My father told me when I was just a child` },
        { start: 119, end: 122, text: `"These are the nights that never die"` },
        { start: 122, end: 126, text: `My father told me` },
        { start: 134, end: 138, text: `"These are the nights that never die"` },
        { start: 138, end: 142, text: `My father told me` },
        { start: 168, end: 172, text: `My father told me` },
    ],
    summer: [
        { start: 3, end: 6, text: `When I met you in the summer` },
        { start: 6, end: 10, text: `To my heartbeat's sound` },
        { start: 10, end: 14, text: `We fell in love` },
        { start: 14, end: 18, text: `As the leaves turned brown` },
        { start: 18, end: 21, text: `And we could be together, baby` },
        { start: 21, end: 25, text: `As long as skies are blue` },
        { start: 25, end: 29, text: `You act so innocent now` },
        { start: 29, end: 32, text: `But you lied so soon` },
        { start: 32, end: 38, text: `When I met you in the summer` },
        { start: 78, end: 82, text: `When I met you in the summer` },
        { start: 82, end: 85, text: `To my heartbeat's sound` },
        { start: 85, end: 89, text: `We fell in love` },
        { start: 89, end: 93, text: `As the leaves turned brown` },
        { start: 93, end: 96, text: `And we could be together, baby` },
        { start: 96, end: 100, text: `As long as skies are blue` },
        { start: 100, end: 104, text: `You act so innocent now` },
        { start: 104, end: 108, text: `But you lied so soon` },
        { start: 108, end: 114, text: `When I met you in the summer` },
        { start: 116, end: 120, text: `Summer` },
        { start: 153, end: 158, text: `When I met you in the summer` },
        { start: 169, end: 173, text: `Summer` },
    ],
    positions: [
        { start: 7, end: 12, text: `Heaven sent you to me` },
        { start: 12, end: 19, text: `I'm just hopin' I don't repeat history` },
        { start: 19, end: 23, text: `Boy, I'm tryna meet your mama on a Sunday` },
        { start: 23, end: 26, text: `Then make a lotta love on a Monday (ah-ah)` },
        { start: 26, end: 29, text: `Never need no (no), no one else, babe` },
        { start: 29, end: 32, text: `'Cause I'll be` },
        { start: 32, end: 34, text: `Switchin' the positions for you` },
        { start: 34, end: 37, text: `Cookin' in the kitchen, and I'm in the bedroom` },
        { start: 37, end: 41, text: `I'm in the Olympics, way I'm jumpin' through hoops` },
        { start: 41, end: 44, text: `Know my love infinite, nothin' I wouldn't do` },
        { start: 44, end: 47, text: `That I won't do, switchin' for y-` },
        { start: 47, end: 49, text: `Perfect, perfect` },
        { start: 49, end: 52, text: `You're too good to be true (you're too good to be true)` },
        { start: 52, end: 55, text: `But I get tired of runnin'` },
        { start: 55, end: 59, text: `Fuck it, now I'm runnin' with you (wit' you)` },
        { start: 59, end: 63, text: `Said, boy, I'm tryna meet your mama on a Sunday` },
        { start: 63, end: 67, text: `Then make a lotta love on a Monday (ah-ah)` },
        { start: 67, end: 70, text: `Never need no (no), no one else, babе` },
        { start: 70, end: 72, text: `'Cause I'll be` },
        { start: 72, end: 74, text: `Switchin' the positions for you (for you, ah)` },
        { start: 74, end: 77, text: `Cookin' in thе kitchen, and I'm in the bedroom` },
        { start: 77, end: 81, text: `I'm in the Olympics, way I'm jumpin' through hoops` },
        { start: 81, end: 84, text: `Know my love infinite, nothin' I wouldn't do` },
        { start: 84, end: 87, text: `That I won't do, switchin' for you` },
        { start: 87, end: 91, text: `Cookin' in the kitchen, and I'm in the bedroom (bedroom)` },
        { start: 91, end: 94, text: `I'm in the Olympics, way I'm jumpin' through hoops` },
        { start: 94, end: 98, text: `Know my love infinite, nothin' I wouldn't do` },
        { start: 98, end: 100, text: `That I won't do, switchin' for you` },
        { start: 100, end: 104, text: `This some shit that I usually don't do (yeah)` },
        { start: 104, end: 107, text: `But for you, I kinda, kinda want to` },
        { start: 107, end: 110, text: `'Cause you're down for me, and I'm down too (and I'm down too)` },
        { start: 110, end: 114, text: `Yeah, I'm down too, switching the positions for you` },
        { start: 114, end: 117, text: `This some shit that I (yeah) usually don't do (don't do)` },
        { start: 117, end: 120, text: `But for you, I kinda, kinda want to` },
        { start: 120, end: 125, text: `'Cause you're down for me, and I'm down too` },
        { start: 125, end: 128, text: `Switchin' the positions for you` },
        { start: 128, end: 131, text: `Cookin' in the kitchen, and I'm in the bedroom` },
        { start: 131, end: 134, text: `I'm in the Olympics, way I'm jumpin' through hoops (to you, to you)` },
        { start: 134, end: 138, text: `Know my love infinite, nothin' I wouldn't do (do)` },
        { start: 138, end: 141, text: `That I won't do, switchin' for you` },
        { start: 141, end: 144, text: `Cookin' in the kitchen and I'm in the bedroom` },
        { start: 144, end: 148, text: `I'm in the Olympics, way I'm jumpin' through hoops` },
        { start: 148, end: 151, text: `Know my love infinite, nothin' I wouldn't do` },
        { start: 151, end: 156, text: `That I won't do, switchin' for you` },
        { start: 156, end: 159, text: `Yeah` },
        { start: 159, end: 161, text: `Ah, yeah` },
        { start: 161, end: 166, text: `Ah (ah), yeah` },
    ],
    'love-is-gone': [
        { start: 14, end: 19, text: `Don't go tonight` },
        { start: 19, end: 22, text: `Stay here one more time` },
        { start: 22, end: 27, text: `Remind me what it's like, oh` },
        { start: 27, end: 34, text: `And let's fall in love one more time` },
        { start: 34, end: 41, text: `I need you now by my side` },
        { start: 41, end: 48, text: `It tears me up when you turn me down` },
        { start: 48, end: 56, text: `I'm begging please, just stick around` },
        { start: 56, end: 62, text: `I'm sorry, don't leave me, I want you here with me` },
        { start: 62, end: 69, text: `I know that your love is gone` },
        { start: 69, end: 76, text: `I can't breathe, I'm so weak, I know this isn't easy` },
        { start: 76, end: 81, text: `Don't tell me that your love is gone` },
        { start: 81, end: 90, text: `That your love is gone` },
        { start: 90, end: 95, text: `Don't tell me that your love is gone` },
        { start: 95, end: 102, text: `That your love is gone` },
        { start: 110, end: 117, text: `I'm sorry, don't leave me, I want you here with me` },
        { start: 117, end: 124, text: `I know that your love is gone` },
        { start: 124, end: 134, text: `I can't breathe, I'm so weak, I know this isn't easy` },
        { start: 134, end: 139, text: `Don't tell me that your love is gone` },
        { start: 139, end: 146, text: `That your love is gone` },
        { start: 146, end: 155, text: `That your love is gone` },
        { start: 155, end: 163, text: `I can't breathe, I'm so weak, I know this isn't easy` },
        { start: 163, end: 168, text: `Don't tell me that your love is gone` },
        { start: 168, end: 175, text: `That your love is gone` },
    ],
    money: [
        { start: 7, end: 10, text: `It's the end of the month and the weekend` },
        { start: 10, end: 13, text: `I'ma spend this check, everything on me, yeah` },
        { start: 13, end: 16, text: `I'ma tip myself, I'ma spend it on myself` },
        { start: 16, end: 19, text: `I'ma drop it like it's pouring, I'ma pour it on myself` },
        { start: 19, end: 21, text: `Check, check, check` },
        { start: 21, end: 24, text: `Check that money making bank account number (yikes)` },
        { start: 24, end: 27, text: `That's that shit that's never getting bounced on ya` },
        { start: 27, end: 30, text: `Bitch, I do the money dance, I just made a hundred bands` },
        { start: 30, end: 34, text: `When the store says "Sign for it, " I'ma leave my autograph` },
        { start: 34, end: 37, text: `Dollar bills, dollar bills` },
        { start: 37, end: 41, text: `Watch it falling for me, I love the way that feels` },
        { start: 41, end: 44, text: `Dollar bills, dollar bills` },
        { start: 44, end: 47, text: `Keep on falling for me, I love the way it feels` },
        { start: 47, end: 52, text: `I came here to drop some money, dropping all my money` },
        { start: 52, end: 56, text: `Drop some money, all this bread so yummy, yeah` },
        { start: 56, end: 59, text: `Twerking, twerking when I buy the things I like` },
        { start: 59, end: 62, text: `Dollar, dollars dropping on my ass tonight` },
        { start: 62, end: 66, text: `Everyone silent, listen to my money talk` },
        { start: 66, end: 68, text: `Spend how I like it` },
        { start: 68, end: 70, text: `Yeah, everyone know what I mean, mean` },
        { start: 70, end: 72, text: `When they see green, when they see green, that mean go` },
        { start: 72, end: 74, text: `Give me what the hell I want` },
        { start: 74, end: 75, text: `Give me what the hell I want` },
        { start: 75, end: 79, text: `Check that money making bank account number (yikes)` },
        { start: 79, end: 82, text: `That's that shit that's never getting bounced on ya` },
        { start: 82, end: 85, text: `Bitch, I do the money dance, I just made a hundred bands` },
        { start: 85, end: 89, text: `When the store says "Sign for it, " I'ma leave my autograph` },
        { start: 89, end: 92, text: `Dollar bills, dollar bills` },
        { start: 92, end: 96, text: `Watch it falling for me, I love the way that feels` },
        { start: 96, end: 99, text: `Dollar bills, dollar bills` },
        { start: 99, end: 102, text: `Keep on falling for me, I love the way it feels` },
        { start: 102, end: 106, text: `I came here to drop some money, dropping all my money` },
        { start: 106, end: 111, text: `Drop some money, all this bread so yummy, yeah` },
        { start: 111, end: 114, text: `Twerking, twerking when I buy the things I like` },
        { start: 114, end: 117, text: `Dollar, dollars, dropping on my ass tonight` },
        { start: 117, end: 120, text: `Drop some money, dropping all my money` },
        { start: 120, end: 123, text: `Drop some money, all this bread so yummy, yeah` },
        { start: 123, end: 127, text: `Drop some money, dropping all my money` },
        { start: 127, end: 136, text: `Drop some money, all this bread so yummy, yeah` },
        { start: 136, end: 140, text: `My money moves, money, I choose` },
        { start: 140, end: 142, text: `Celine, my shoes, walking on you` },
        { start: 142, end: 144, text: `My money rules` },
        { start: 144, end: 147, text: `My money moves, money, I choose` },
        { start: 147, end: 151, text: `Watch how my Wons and Yens and Dollars be dropping on you, you, you` },
        { start: 151, end: 155, text: `Dun, da, la, la, dun-dun, dun, da-la-la, dun-dun` },
        { start: 155, end: 158, text: `Dun, da, la, la, dun-dun, dropping on you` },
        { start: 158, end: 161, text: `Dun, da, la, la, dun-dun, dun, da-la-la, dun-dun` },
        { start: 161, end: 166, text: `Dun, da, la, la, dun-dun, dropping on you` },
    ],
    'мокрые-кроссы': [
        { start: 27, end: 30, text: `Молчит экран, и я бы хотел вместе с ним` },
        { start: 30, end: 34, text: `Просто забрать тебя себе и держать из всех сил` },
        { start: 34, end: 36, text: `Но новый день, и я опять невыносим` },
        { start: 36, end: 40, text: `И ты уходишь, будто бы я тебя попросил` },
        { start: 40, end: 43, text: `И я вроде как счастлив, но явно к тебе привязан` },
        { start: 43, end: 46, text: `На нашей улице сказки, фонари для нас не гаснут` },
        { start: 46, end: 49, text: `Можешь продолжить нести чушь, легче не станет никому` },
        { start: 49, end: 54, text: `Так что прыгай ко мне пока я ловлю` },
        { start: 54, end: 56, text: `Да ладно - я словлю` },
        { start: 56, end: 59, text: `И пускай капает, капает с неба` },
        { start: 59, end: 62, text: `Иду в мокрых кроссах к тебе где бы я не был` },
        { start: 62, end: 66, text: `Для остальных я занят, звонки без ответа` },
        { start: 66, end: 69, text: `Дойти бы к тебе, дойти бы к тебе` },
        { start: 69, end: 72, text: `И пускай капает, капает с неба` },
        { start: 72, end: 76, text: `Иду в мокрых кроссах к тебе где бы я не был` },
        { start: 76, end: 79, text: `Для остальных я занят, звонки без ответа` },
        { start: 79, end: 84, text: `Дойти бы к тебе, дойти бы к тебе` },
        { start: 84, end: 87, text: `Не замечай меня, ведь я ухожу вне` },
        { start: 87, end: 91, text: `Не зови меня назад, ведь там нас больше нет` },
        { start: 91, end: 93, text: `Я вновь закрыл глаза и закрылся от всех` },
        { start: 93, end: 97, text: `Так что останешься ли ты больше неважно мне` },
        { start: 97, end: 100, text: `Видишь мокрый насквозь до глубины души` },
        { start: 100, end: 104, text: `И этот недо дождик не сможет потушить` },
        { start: 104, end: 107, text: `Желание дойти хотя бы поговорить` },
        { start: 107, end: 109, text: `И я падаю без сил` },
        { start: 109, end: 113, text: `И мне не нужен зонт, мне не нужен никто` },
        { start: 113, end: 117, text: `Хлюпали мокрые кроссы по лужам, и я знал, что меня ждет` },
        { start: 117, end: 119, text: `Ведь нас с тобой как никого несет` },
        { start: 119, end: 121, text: `Так что можешь молчать и дальше` },
        { start: 121, end: 124, text: `Но чтобы понять мне не надо слов` },
        { start: 124, end: 127, text: `Для других нас нет, ноги еле плетутся` },
        { start: 127, end: 130, text: `С нами свобода ветра, только не надо дуться` },
        { start: 130, end: 133, text: `Я пройду километры, не захочу вернуться` },
        { start: 133, end: 139, text: `Все будет хорошо, но мне надо переобуться` },
        { start: 139, end: 142, text: `И пускай капает, капает с неба` },
        { start: 142, end: 146, text: `Иду в мокрых кроссах к тебе где бы я не был` },
        { start: 146, end: 149, text: `Для остальных я занят, звонки без ответа` },
        { start: 149, end: 152, text: `Дойти бы к тебе, дойти бы к тебе` },
        { start: 152, end: 156, text: `И пускай капает, капает с неба` },
        { start: 156, end: 159, text: `Иду в мокрых кроссах к тебе где бы я не был` },
        { start: 159, end: 162, text: `Для остальных я занят, звонки без ответа` },
        { start: 162, end: 166, text: `Дойти бы к тебе, дойти бы к тебе` },
        { start: 166, end: 169, text: `И пускай капает, капает с неба` },
        { start: 169, end: 172, text: `Иду в мокрых кроссах к тебе где бы я не был` },
        { start: 172, end: 176, text: `Для остальных я занят, звонки без ответа` },
        { start: 176, end: 179, text: `Дойти бы к тебе, дойти бы к тебе` },
        { start: 179, end: 182, text: `И пускай капает, капает с неба` },
        { start: 182, end: 185, text: `Иду в мокрых кроссах к тебе где бы я не был` },
        { start: 185, end: 189, text: `Для остальных я занят, звонки без ответа` },
        { start: 189, end: 195, text: `Дойти бы к тебе, дойти бы к тебе` },
    ],
    улети: [
        { start: 9, end: 14, text: `Слово «навсегда» мы клеили из пепла` },
        { start: 14, end: 18, text: `Все эти слова под открытым небом` },
        { start: 18, end: 22, text: `Прошлым чувствам я закрыл глаза, веки` },
        { start: 22, end: 25, text: `Прости, малая, но мне надоело` },
        { start: 25, end: 29, text: `Улети и не вспоминай меня` },
        { start: 29, end: 34, text: `Улети и не вспоминай меня` },
        { start: 34, end: 38, text: `Улети и не вспоминай меня` },
        { start: 38, end: 44, text: `Улети и не вспоминай меня` },
        { start: 44, end: 53, text: `Улети, но не забудь сказать «пока»` },
        { start: 53, end: 61, text: `Улети, но не забудь сказать «пока»` },
        { start: 61, end: 65, text: `Улетай, ты же знаешь, это все` },
        { start: 65, end: 70, text: `Я бы пропал, но я себя и не нашел` },
        { start: 70, end: 74, text: `Я попросил тебя остаться, но ты минимум должна` },
        { start: 74, end: 78, text: `Открыть глаза и сделать то, что я прошу` },
        { start: 78, end: 82, text: `Улети и не вспоминай меня` },
        { start: 82, end: 86, text: `Улети и не вспоминай меня` },
        { start: 86, end: 91, text: `Улети и не вспоминай меня` },
        { start: 91, end: 97, text: `Улети и не вспоминай меня` },
        { start: 97, end: 99, text: `Улети, но не забудь сказать «пока»` },
        { start: 99, end: 105, text: `Не забудь, не забудь` },
        { start: 105, end: 108, text: `Улети, но не забудь сказать «пока»` },
        { start: 108, end: 112, text: `Не забудь, не забудь` },
        { start: 131, end: 136, text: `В первый раз я захотел уйти с начала` },
        { start: 136, end: 140, text: `В первый раз я говорил тебе: «Не надо»` },
        { start: 140, end: 145, text: `Просто забери себя, прощай, oh yeah` },
        { start: 145, end: 149, text: `Я не хочу видеть тебя` },
        { start: 149, end: 154, text: `Я тебя проведу, но знай, что больше не хочу быть поближе` },
        { start: 154, end: 158, text: `Я тебя украл когда-то, но я верну тебя, слышишь` },
        { start: 158, end: 162, text: `Я не могу тебе дать то, что ты хотела так получить, я лишний` },
        { start: 162, end: 165, text: `В этом сладком мире` },
        { start: 165, end: 169, text: `Улети и не вспоминай меня` },
        { start: 169, end: 174, text: `Улети и не вспоминай меня` },
        { start: 174, end: 178, text: `Улети и не вспоминай меня` },
        { start: 178, end: 184, text: `Улети и не вспоминай меня` },
        { start: 186, end: 196, text: `Пока, пока, пока` },
    ],
};

export default WORLD_MUSIC_LYRICS;
